<template>
  <div
    :class="'family-card ' + code"
    :id="code"
    @click="gotoFamilyLink(codice)"
    :style="
      'background-image: url(' +
      url('/media/articles/images/families/' + code + '.jpg') +
      ');'
    "
  >
    <img
      v-if="!imageError"
      :src="url('/media/icons/svg/family/white/' + code.toLowerCase() + '.svg')"
      @error="imageError = true"
      :alt="code + ' icon'"
    />
    <img
      v-else
      style="filter: blur(4px)"
      :src="url('/media/icons/svg/family/white/c.svg')"
      :alt="code + ' icon'"
    />
    <p>{{ descrizione }}</p>
    <a
      :href="url('/catalog/' + macro + '/family/' + codice)"
      class="prod-scopri d-flex"
      ><span>{{ trans.get('public.explore') }}</span
      ><img :src="url('/media/icons/svg/arrow-right_white.svg')" alt="arrow"
    /></a>
  </div>
</template>

<script>
export default {
  name: "families",
  props: ["macro", "codice", "descrizione", "active"],
  data() {
    return {
      imageError: false,
      code: this.codice,
    };
  },
  mounted() {
    this.parseFilename();
    this.isActive();
  },
  updated() {
    this.isActive();
  },
  watch: {
    active: function () {
      if (this.active) {
        $("#" + this.code + " .selected-bar").css("opacity", 1);
        $("#" + this.code + " p").css("color", "#fff");
        $("#" + this.code + ".family-card img").css({
          filter: "brightness(1)",
        });
        if (this.imageError) {
          $("#" + this.code + ".family-card img").css({ filter: "blur(4px)" });
        }
      } else {
        $("#" + this.code + " .selected-bar").css("opacity", 0);
        $("#" + this.code + " p").css("color", "#707070");
        $("#" + this.code + ".family-card img").css({
          filter: "brightness(.5)",
        });
        if (this.imageError) {
          $("#" + this.code + ".family-card img").css({ filter: "blur(4px)" });
        }
      }
    },
  },

  methods: {
    gotoFamilyLink: function (codfam) {
      window.location.replace(
        window.location.origin + `/catalog/${this.macro}/family/${codfam}`
      );
    },
    isActive: function () {
      if (this.active) {
        // console.log(this.code, $("#" + this.code).length);
        $("#" + this.code + " .selected-bar").css("opacity", 1);
        $("#" + this.code + " p").css("color", "#fff");
        $("#" + this.code + ".family-card img").css({
          filter: "brightness(1)",
        });
      }
    },
    emitActive: function () {
      this.$emit("active", this.codice);
    },
    parseFilename: function () {
      this.code = this.code.replace(/\+/g, "plus");
    },
  },
};
</script>

<style lang="scss" scoped>
.family-card {
  cursor: pointer;
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: overlay;
  transition: all 0.5s linear;
  //@media (min-width: 2000px){
  //  width: 400px;
  //  height: 200px;
  //}
  &:hover {
    background-blend-mode: initial;


    .selected-bar {
      opacity: 1;
    }
  }

  background-color: #2f2f34;

  img {
    margin-top: auto;
    width: 60px;
    transition: all 0.5s linear;

    &.active {
      filter: brightness(1);
    }
  }
  p {
    text-transform: lowercase;
    font-size: 16px;
    text-align: center;
    color: #fff;
    transition: all 0.5s linear;

    &:first-letter {
      text-transform: uppercase;
    }
  }
  .selected-bar {
    margin-top: 2px;
    opacity: 0;
    background-color: var(--greenb2b);
    height: 3px;
    width: 100%;
    transition: all 0.5s linear;
  }
  .prod-scopri {
    margin-top: auto;
    margin-bottom: 20px;
   align-items: center;
    span {
      font-size: 16px;
    }
    img {
      margin-top: 0;
      width: 40px;
      margin-left: 10px;
    }
    align-self: flex-end;
    margin-right: 30px;
  }
  &.T {
    background-position: center bottom;
  }
}
</style>
